import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://676c6529ec9c428bcd738528df5012f3@o4511804990488576.ingest.de.sentry.io/4511805016899664",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
});
